import { warps, wefts, initDraftFromDrawdown, updateWeftSystemsAndShuttles, updateWarpSystemsAndShuttles } from "../../draft";
import { Sequence } from "../../sequence";
import { defaults, lcm } from "../../utils";
import { compoundOp } from "../categories";
import { getAllDraftsAtInlet, parseDraftNames } from "../operations";
import { OperationParam, OperationInlet, OpParamVal, OpInput, Operation, OpMeta } from "../types";


const name = "overlay_multiple";

const meta: OpMeta = {
  displayname: 'overlay multiple',
  desc: 'This function will take the lifted heddles within each draft and combine them to make a composite draft whereby each draft can be understood to be overlaid upon each other. The resulting draft size is recalculated in order to ensure equal repeats',
  img: 'overlay_multiple.png',
  categories: [compoundOp],
  advanced: true
}


//PARAMS


const params: Array<OperationParam> = [];

//INLETS
const drafts: OperationInlet = {
  name: 'draft',
  type: 'static',
  value: null,
  uses: "draft",
  dx: 'all the drafts you would like to overlay another onto',
  num_drafts: -1
}



const inlets = [drafts];


const perform = (op_params: Array<OpParamVal>, op_inputs: Array<OpInput>) => {

  const drafts = getAllDraftsAtInlet(op_inputs, 0);

  if (drafts.length == 0) return Promise.resolve([]);

  const sys_seq = new Sequence.OneD([0]);

  const composite = new Sequence.TwoD().setBlank(2);
  const ends = lcm(drafts.map(el => warps(el.drawdown)), defaults.lcm_timeout);
  const pics = lcm(drafts.map(el => wefts(el.drawdown)), defaults.lcm_timeout);



  drafts.forEach((draft) => {
    const seq = new Sequence.TwoD().import(draft.drawdown);
    seq.mapToSystems([0], [0], sys_seq, sys_seq, ends, pics);
    composite.overlay(seq, true);
  })


  let d = initDraftFromDrawdown(composite.export());
  d = updateWeftSystemsAndShuttles(d, drafts[0]);
  d = updateWarpSystemsAndShuttles(d, drafts[0]);

  return Promise.resolve([{ draft: d }]);
}

const generateName = (param_vals: Array<OpParamVal>, op_inputs: Array<OpInput>): string => {
  const drafts = getAllDraftsAtInlet(op_inputs, 0);
  return 'overlay_multi' + parseDraftNames(drafts) + ")";
}

const sizeCheck = (op_settings: Array<OpParamVal>, op_inputs: Array<OpInput>): boolean => {
  const drafts = getAllDraftsAtInlet(op_inputs, 0);

  if (drafts.length == 0) return true;

  const ends = lcm(drafts.map(el => warps(el.drawdown)), defaults.lcm_timeout);
  const pics = lcm(drafts.map(el => wefts(el.drawdown)), defaults.lcm_timeout);

  return (ends * pics <= defaults.max_area) ? true : false;
}

export const overlay_multiple: Operation = { name, meta, params, inlets, perform, generateName, sizeCheck };